module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_750-Red-eeeb8ec588e01bc971a8a6f55f057b81.png";